import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { type ProviderLimitedDetail, ProviderService } from '../../api';
import { Scheduler } from '../../app/components/Scheduler';
import { ProviderLimitContext } from '../../app/contexts/ProviderLimitContext';
import { useProviderId } from '../../app/hooks/providers';
import { useDocumentTitle } from '../../app/hooks/use-document-title';
import { providerQueryKeys } from '../../app/query-keys-factories/providers';

export const ProviderSchedule = ({
  readOnly = false,
  isBooking = false,
  onHomePage = false,
}: {
  readOnly?: boolean;
  isBooking?: boolean;
  onHomePage?: boolean;
}) => {
  // Only set document title when not on home page to avoid overriding parent title
  useDocumentTitle('Provider Schedule', false, !onHomePage);
  const providerId = useProviderId();
  const [providerLimit, setProviderLimit] = useState<ProviderLimitedDetail | null>(null);
  const { data: provider } = useQuery({
    queryKey: providerQueryKeys.limitedDetail(providerId!),
    queryFn: async () =>
      await ProviderService.providerLimitedRetrieve({
        providerId: providerId!,
      }),
    enabled: !!providerId,
    onSuccess: (data) => {
      setProviderLimit(data);
    },
  });

  return (
    <div className="row-cols-auto justify-content-center">
      {providerId && (
        <Row>
          <Col xs={12}>
            <div className={`${onHomePage ? 'px-4' : 'p-4'}`}>
              <ProviderLimitContext.Provider value={{ providerLimit, setProviderLimit }}>
                <Scheduler providerId={providerId} provider={provider} isBooking={isBooking} />
              </ProviderLimitContext.Provider>
            </div>
          </Col>
        </Row>
      )}
    </div>
  );
};
